/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as React from "react";
import ReactDOM from "react-dom";
import { registerSW } from "virtual:pwa-register";
import { Config, initConfig } from "./config";
import { registerPDFTronServiceWorker } from "./config/pdftron/service-worker/register-pdftron-sw";
import { App } from "./screens/App/App";

const updateSW = registerSW({
  onNeedRefresh() {
    void updateSW(true);
  },
  onOfflineReady() {
    console.log("offline ready");
  },
});

void main();

async function main() {
  await initConfig();
  console.info("🍀 Welcome on Clovis");

  ReactDOM.render(
    <React.StrictMode>
      <Config>
        <App />
      </Config>
    </React.StrictMode>,
    document.getElementById("root")
  );

  await registerPDFTronServiceWorker();
}
